<template>
  <v-dialog v-model="showExportDialog" max-width="500" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-container class="pa-1" style="">
        <v-fab-transition>
          <v-btn
            v-on="on"
            v-bind="attrs"
            class="ma-2 top-right-agreements-mobile-export"
            fab
            small
            :disabled="!locationCount"
            v-if="isMobile"
          >
            <v-icon> mdi-download </v-icon>
          </v-btn>

          <v-btn
            v-on="on"
            v-bind="attrs"
            color="primary"
            class="ma-2 top-right-agreements-export"
            style="
              width: 200px;
              min-height: 40px !important;
              font-weight: 500 !important;
            "
            outlined
            depressed
            :disabled="!locationCount"
            rounded
            v-if="!isMobile"
          >
            <v-icon style="font-size: 1.4rem !important" class="pr-2">
              mdi-download
            </v-icon>
            Daten exportieren
          </v-btn>
        </v-fab-transition>
      </v-container>
    </template>
    <v-card>
      <v-card-title>Exportieren</v-card-title>
      <v-card-subtitle class="pb-2"
        >Standort: {{ locationDetail.displayName }}
      </v-card-subtitle>
      <v-container class="pt-0">
        <v-form
          @submit.prevent="exportReport"
          ref="exportForm"
          class="export-form"
        >
          <v-col cols="12" v-if="isMobile">
            <v-text-field
              v-model="email"
              type="string"
              label="Email:"
              outlined
              :rules="emailRules"
            />
          </v-col>
          <v-row>
            <v-col cols="5">
              <span class="subheading">Report Format:</span>
            </v-col>
            <v-col cols="7">
              <v-chip-group
                v-model="reportFormat"
                active-class="v-btn--active text--accent-4"
                mandatory
              >
                <v-chip
                  v-for="format in formats"
                  :key="format.id"
                  :value="format.type"
                  >{{ format.type }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="5">
              <span class="subheading">Alle Standorte?</span>
            </v-col>
            <v-col cols="7">
              <v-chip-group
                v-model="allLocations"
                active-class="v-btn--active text--accent-4"
                mandatory
              >
                <v-chip :value="false">Nein</v-chip>
                <v-chip :value="true">Ja</v-chip>
              </v-chip-group>
            </v-col>
          </v-row>

          <v-card-actions class="center flex-wrap">
            <v-btn
              class="mt-1"
              color="warning"
              outlined
              @click="
                showExportDialog = false;
                resetFormValues();
              "
              >Abbrechen
            </v-btn>
            <v-spacer />
            <v-btn class="mt-1" color="primary" type="submit"
              >Jetzt exportieren</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { ApiUrl } from "@/config/ApiUrl";
import { EventBus, emailRules } from "@/helpers";
import { mapGetters, mapState } from "vuex";

export default Vue.extend({
  props: ["reportType"],
  ...{
    data: () => {
      return {
        user: Object,
        email: "example@company.de", //userInfo.user.email,
        reportFormat: "xlsx",
        formats: [
          { id: 1, type: "csv" },
          { id: 2, type: "xlsx" },
        ],
        allLocations: "false",
        showExportDialog: false,
        triedSubmit: false,
        emailRules: emailRules,
      };
    },
    mounted() {
      this.user = this.userInfo.user;
      this.email = this.userInfo.user.email;
    },
    computed: {
      ...mapState({
        locations: (state) => state.company.locations,
        locationDetail: (state) => state.company.locationDetail,
        orderCount: (state) => state.company.orderCount,
        userInfo: (state) => state.user,
      }),
      ...mapGetters({ locationCount: "locationCount" }),
      isMobile() {
        return this.$vuetify.breakpoint.width < 768;
      },
      getReportType() {
        if (this.reportType === "agreement") {
          return "Vereinbarungen";
        } else if (this.reportType === "orderHistory") {
          return "Auftragshistorie";
        }
      },
    },
    methods: {
      resetFormValues() {
        this.showExportDialog = false;
        this.email = this.userInfo.user.email;
        this.reportFormat = "xlsx";
      },
      exportReport() {
        EventBus.$emit("loading", "_", { detail: true });
        const todayDate = new Date().toISOString().substring(0, 10);
        const format = this.reportFormat;
        const filename = `${todayDate}_${this.getReportType}.${format}`;

        const _data = {
          reportFormat: format,
        };
        if (!this.allLocations) {
          _data["serviceLocationId"] = this.locationDetail.id;
        }
        if (this.isMobile) {
          _data["reportEmail"] = this.email;
        }
        if (this.reportType === "orderHistory") {
          axios({
            url: ApiUrl.EXPORT_ORDERSHISTORY,
            data: _data,
            headers: {
              "Content-Disposition": `attachment; filename=${filename}`,
            },
            responseType: "arraybuffer",
            method: "POST",
          })
            .then((response) => {
              if (!this.isMobile) {
                const url = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
              } else {
                this.$toast("E-Mail erfolgreich gesendet!", {
                  timeout: 5000,
                });
              }
            })
            .catch(() => {
              this.$toast.error(
                "Vereinbarungen konnte nicht empfangen werden."
              );
            });
        } else if (this.reportType === "agreement") {
          axios({
            url: ApiUrl.EXPORT_AGREEMENTS,
            data: _data,
            headers: {
              "Content-Disposition": `attachment; filename=${filename}`,
            },
            responseType: "arraybuffer",
            method: "POST",
          })
            .then((response) => {
              if (!this.isMobile) {
                const url = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
              } else {
                this.$toast("E-Mail erfolgreich gesendet!", {
                  timeout: 5000,
                });
              }
            })
            .catch(() => {
              this.$toast.error(
                "Vereinbarungen konnten nicht empfangen werden."
              );
            });
        }
        this.showExportDialog = false;
      },
    },
  },
});
</script>
<style lang="sass" scoped>
.top-right-agreements-export, .top-right-agreements-mobile-export
  position: absolute
  right: 0.8em
  top: 0
  z-index: 5

.top-right-agreements-export
  background-color: white !important

.rn-Agreements .top-right-agreements-export
  right: 16rem

.top-right-agreements-mobile-export
  position: fixed
  right: 5px
  bottom: 75px
  top: 0
  z-index: 5
  border-radius: 10% !important
  background-color: transparent !important
  box-shadow: none !important
  opacity: 0.65

.export-form
  margin: 20px !important

.v-btn--active
  background-color: $primary !important
  color: lighten(#fff, 10%) !important
</style>
